var _a;
import { __extends } from "tslib";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { clickManagerContext } from '../../util/contextNamespace';
var DropdownItemClickManager = /** @class */ (function (_super) {
    __extends(DropdownItemClickManager, _super);
    function DropdownItemClickManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleItemClicked = function (event) {
            _this.props.onItemClicked(event);
        };
        return _this;
    }
    DropdownItemClickManager.prototype.getChildContext = function () {
        var _a;
        return _a = {},
            _a[clickManagerContext] = {
                itemClicked: this.handleItemClicked,
            },
            _a;
    };
    DropdownItemClickManager.prototype.render = function () {
        return this.props.children;
    };
    DropdownItemClickManager.childContextTypes = (_a = {},
        // eslint-disable-next-line react/forbid-prop-types
        _a[clickManagerContext] = PropTypes.object,
        _a);
    return DropdownItemClickManager;
}(Component));
export default DropdownItemClickManager;
//# sourceMappingURL=DropdownItemClickManager.js.map